// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"

import TestimonyCard from "./../common/testimony-card"
import Content from "./../../content/about-us/philip-testimony.json"

const PhilipCard = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query PhilipCardQuery {
      Philip: file(relativePath: { eq: "about-us/philip.jpg" }) {
        childImageSharp {
          # Other options include height (set both width and height to crop),
          # grayscale, duotone, rotate, etc.
          fixed(width: 125, height: 125) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  const { name, position, paragraph } = Content[langKey]
  return (
    <TestimonyCard
      fixedImg={data.Philip.childImageSharp.fixed}
      name={name}
      position={position}
      paragraph={paragraph}
    />
  )
}

export default PhilipCard
